import {Component, Inject} from '@angular/core';
import {SuppliersService} from '../../../services/suppliers.service';
import {MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef} from '@angular/material/bottom-sheet';

@Component({
  selector: 'ps-pm-create-snr',
  templateUrl: 'pm-create-snr.component.html'
})
export class PmCreateSnrComponent {
  index: string;
  name: string;
  description: string;

  constructor(private suppliersService: SuppliersService, private bs: MatBottomSheetRef, @Inject(MAT_BOTTOM_SHEET_DATA) private data) {
  }

  save() {
    this.suppliersService.insertSnr(this.data.constructionId, this.data.indexId, this.name, this.description, this.index).subscribe(result => {
      this.bs.dismiss(result);
    });
  }

  cancel() {
    this.bs.dismiss();
  }
}
